import React from 'react';
import PdvService from '../../../services/pdv';
import { cpfOrCnpjMask, dateMask, celPhoneMask, cepMask, unMask } from '../../../commons/masks';
import { convertPercentToDecimal, convertDecimalToPercent } from '../../../commons/utils';
import useForm from '../../components/useForm';
import PdvForm from '../form';

const PdvEditForm = (props) => {
  const { setMessage, goToMenu } = props;
  const pdv = JSON.parse(sessionStorage.getItem('pdv'));
  const address = pdv.address;

  const initialFormValues = {
    cpf_cnpj: cpfOrCnpjMask(pdv.cpf_cnpj),
    name: pdv.name,
    email: pdv.email,
    birthday: dateMask(pdv.birthday),
    phone: celPhoneMask(pdv.phone),
    discount: convertDecimalToPercent(pdv.discount),
    isPartner: (pdv.isPartner ? '1' : '2'),
    password: '',
    passwordNew: '',
    passwordConfirmation: '',
    address: {
      street: address ? address.street : '',
      number: address ? address.number : '',
      district: address ? address.district : '',
      city: address ? address.city : '',
      zipCode: address ? cepMask(address.zipCode) : '',
    }
  }

  const {
    values,
    setValues,
    status,
    setStatus,
    stateButton,
    setStateButton,
    handleInputChange
  } = useForm(initialFormValues);

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStatus('');
    setStateButton("loading");
    if (values.passwordNew && values.passwordNew !== values.passwordConfirmation) {
      setStatus(['danger', 'As senhas não coincidem.']);
    } else {
      try {
        const pdvUpdate = {
          id: pdv._id,
          name: values.name,
          email: values.email,
          birthday: values.birthday.replace(/\//g,'-'),
          cpf_cnpj: unMask(values.cpf_cnpj),
          phone: unMask(values.phone),
          password: values.password,
          newPassword: values.passwordNew,
          discount: convertPercentToDecimal(values.discount),
          isPartner: (values.isPartner==="1"),
          address: {
            ...values.address,
            zipCode: unMask(values.address.zipCode)
          }
        }
        const response = await PdvService.edit(pdvUpdate);
        await PdvService.findByCpf(unMask(values.cpf_cnpj));
        setMessage(['success', response.data.message]);
        goToMenu();
      } catch(e) {
        if (e.response)
          setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
        else
          setStatus(['danger', `${e}`]);
      }
    }
    setStateButton('');
  }

  return (
    <PdvForm 
      editRecord={true}
      status={status} 
      setValues={setValues}
      stateButton={stateButton} 
      values={values} 
      handleInputChange={handleInputChange}
      handleSubmit={handleSubmit}
      handleClickBack={goToMenu}
    />
  )

}

export default PdvEditForm;
